// import React, { useEffect, useMemo, useRef, useState } from "react";
// import { MessageCircle, X, Send } from "lucide-react";

// const WEBHOOK_URL = "https://apitrackk.pickkup.io/api/v1/chatbot";
// const SESSION_KEY = "bhejogaadi-session-id";
// const STATE_KEY = "bhejogaadi-state-b64";
// const MESSAGES_KEY = "bhejogaadi-messages-v1";

// function nowTimestamp() {
//   const d = new Date();
//   return d.toLocaleString();
// }

// export default function FloatingChat() {
//   const [open, setOpen] = useState(false);
//   const [messages, setMessages] = useState(() => {
//     try {
//       const raw = localStorage.getItem(MESSAGES_KEY);
//       return raw ? JSON.parse(raw) : [];
//     } catch {
//       return [];
//     }
//   });
//   const [input, setInput] = useState("");
//   const [busy, setBusy] = useState(false);
//   const [typing, setTyping] = useState(false);
//   const chatRef = useRef(null);
//   const inputRef = useRef(null);

//   // sessionId - persistent
//   const sessionId = useMemo(() => {
//     let sid = localStorage.getItem(SESSION_KEY);
//     if (!sid) {
//       sid = "web-" + Math.random().toString(36).slice(2);
//       localStorage.setItem(SESSION_KEY, sid);
//     }
//     return sid;
//   }, []);

//   const getState = () => localStorage.getItem(STATE_KEY) || "";
//   const setState = (s) => localStorage.setItem(STATE_KEY, s || "");

//   // persist messages to localStorage whenever they change
//   useEffect(() => {
//     try {
//       localStorage.setItem(MESSAGES_KEY, JSON.stringify(messages));
//     } catch (e) {
//       // ignore quota issues
//       console.warn("Could not persist messages:", e);
//     }
//   }, [messages]);

//   // Scroll chat to bottom (smooth)
//   useEffect(() => {
//     if (chatRef.current) {
//       chatRef.current.scrollTo({
//         top: chatRef.current.scrollHeight,
//         behavior: "smooth",
//       });
//     }
//   }, [messages, typing, busy]);

//   // Add initial greeting when chat opens (only once)
//   useEffect(() => {
//     if (open && messages.length === 0) {
//       setMessages([
//         {
//           who: "bot",
//           text: "👋 Hi! I am your assistant. How may I assist you?",
//           ts: nowTimestamp(),
//         },
//       ]);
//     }
//   }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

//   // focus input when open
//   useEffect(() => {
//     if (open && inputRef.current) {
//       setTimeout(() => inputRef.current.focus(), 80);
//     }
//   }, [open]);

//   // Send user message
//   async function sendMessage() {
//     const text = input.trim();
//     if (!text || busy) return;

//     const userMsg = { who: "me", text, ts: nowTimestamp() };
//     setMessages((prev) => [...prev, userMsg]);
//     if (window.gtag) {
//       window.gtag("event", "chatbot_message_sent", {
//         event_category: "chatbot",
//         event_label: text,
//         value: text.length,
//       });
//     }
//     setInput("");
//     setBusy(true);
//     setTyping(true);

//     try {
//       const res = await fetch(WEBHOOK_URL, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "X-Session-Id": sessionId,
//         },
//         body: JSON.stringify({ message: text, sessionId, state: getState() }),
//       });

//       const raw = await res.text();

//       if (!res.ok) {
//         console.error("Non-OK response from webhook:", res.status, raw);
//         setMessages((prev) => [
//           ...prev,
//           {
//             who: "bot",
//             text: `⚠ Server error (${res.status}). Please try again later.`,
//             ts: nowTimestamp(),
//           },
//         ]);
//         if (window.gtag) {
//           window.gtag("event", "chatbot_message_received", {
//             event_category: "chatbot",
//             event_label: replyText.substring(0, 50), // first 50 chars
//           });
//         }
//         return;
//       }

//       let data;
//       try {
//         data = raw ? JSON.parse(raw) : {};
//       } catch (err) {
//         console.warn("Invalid JSON from webhook:", raw);
//         // fallback to raw text
//         data = { reply: raw || "No reply from bot" };
//       }

//       const replyText =
//         data.reply || data.message || data.text || "No reply from bot";

//       // optional: update state returned from server (if provided)
//       if (data.state) {
//         setState(data.state);
//       }

//       setMessages((prev) => [
//         ...prev,
//         { who: "bot", text: replyText, ts: nowTimestamp() },
//       ]);
//     } catch (e) {
//       console.error("Chat fetch error:", e);
//       setMessages((prev) => [
//         ...prev,
//         {
//           who: "bot",
//           text: "⚠ Error: unable to reach server.",
//           ts: nowTimestamp(),
//         },
//       ]);
//     } finally {
//       setBusy(false);
//       setTyping(false);
//     }
//   }

//   const onKeyDown = (e) => {
//     // Enter = send, Shift+Enter = newline
//     if (e.key === "Enter" && !e.shiftKey) {
//       e.preventDefault();
//       if (!busy) sendMessage();
//     }
//   };

//   const clearChat = () => {
//     setMessages([]);
//     localStorage.removeItem(MESSAGES_KEY);
//     localStorage.removeItem(STATE_KEY);
//   };

//   return (
//     <>
//       {!open && (
//   <button
//     style={styles.fab}
//     onClick={() => {
//       setOpen(true);

//       // GA event
//       if (window.gtag) {
//         window.gtag("event", "chatbot_opened", {
//           event_category: "chatbot",
//           event_label: "User opened chatbot",
//         });
//       }
//     }}
//     aria-label="Open chat"
//     title="Open chat"
//   >
//     <img
//       src="/assets/images/bot.png"
//       alt="Chatbot"
//       style={{ width: 26, height: 26 }}
//     />
//   </button>
// )}


//       {open && (
//         <div style={styles.wrap} role="dialog" aria-label="Support chat window">
//           <div style={styles.header}>
//             <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
//               <MessageCircle size={16} />
//               <span>Pickkup Support</span>
//               <span style={{ fontSize: 12, opacity: 0.9, marginLeft: 8 }}>
//                 {busy || typing ? "• typing…" : "• online"}
//               </span>
//             </div>

//             <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
//               <button
//                 onClick={clearChat}
//                 title="Clear chat"
//                 aria-label="Clear chat"
//                 style={{
//                   background: "transparent",
//                   border: "none",
//                   color: "#ffffff",
//                   cursor: "pointer",
//                   fontSize: 13,
//                 }}
//               >
//                 Clear
//               </button>

//               <button
//                 style={styles.close}
//                 onClick={() => setOpen(false)}
//                 aria-label="Close chat"
//                 title="Close chat"
//               >
//                 <X size={18} />
//               </button>
//             </div>
//           </div>

//           <div
//             ref={chatRef}
//             style={styles.chat}
//             tabIndex={0}
//             aria-live="polite"
//           >
//             {messages.length === 0 && (
//               <div
//                 style={{ textAlign: "center", color: "#888", marginTop: 16 }}
//               >
//                 Start the conversation...
//               </div>
//             )}

//             {messages.map((m, i) => (
//               <div
//                 key={i}
//                 style={{
//                   ...styles.msg,
//                   ...(m.who === "me" ? styles.me : styles.bot),
//                 }}
//                 aria-label={`${m.who} message`}
//               >
//                 <div style={{ whiteSpace: "pre-wrap" }}>{m.text}</div>
//                 <div
//                   style={{
//                     fontSize: 11,
//                     opacity: 0.65,
//                     marginTop: 6,
//                     textAlign: m.who === "me" ? "right" : "left",
//                   }}
//                 >
//                   {m.ts || ""}
//                 </div>
//               </div>
//             ))}

//             {typing && (
//               <div style={{ ...styles.msg, ...styles.bot }}>
//                 <div style={{ fontStyle: "italic" }}>Meena is typing…</div>
//               </div>
//             )}
//           </div>

//           <div style={styles.row}>
//             <textarea
//               ref={inputRef}
//               style={{ ...styles.input, resize: "none", height: 40 }}
//               placeholder="Type a message"
//               value={input}
//               onChange={(e) => setInput(e.target.value)}
//               onKeyDown={onKeyDown}
//               disabled={busy}
//               aria-label="Message input"
//             />

//             <button
//               style={{
//                 ...styles.button,
//                 opacity: input.trim() ? 1 : 0.6,
//                 cursor: input.trim() && !busy ? "pointer" : "not-allowed",
//               }}
//               onClick={sendMessage}
//               disabled={busy || !input.trim()}
//               aria-label="Send message"
//               title="Send"
//             >
//               {busy ? "…" : <Send size={18} />}
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// const styles = {
//   fab: {
//     position: "fixed",
//     bottom: "20px",
//     right: "20px",
//     width: "60px",
//     height: "60px",
//     borderRadius: "50%",
//     background: "#ffffff",
//     color: "#333333",
//     border: "1px solid #ccc",
//     cursor: "pointer",
//     fontSize: "24px",
//     boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
//     zIndex: 1001,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   wrap: {
//     position: "fixed",
//     bottom: "20px",
//     right: "20px",
//     width: "360px",
//     height: "480px",
//     fontFamily: "system-ui, sans-serif",
//     color: "#333333",
//     background: "#ffffff",
//     border: "1px solid #ddd",
//     borderRadius: "12px",
//     boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
//     display: "flex",
//     flexDirection: "column",
//     zIndex: 1002,
//     overflow: "hidden",
//     animation: "fadeInUp 0.18s ease",
//   },
//   header: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     fontWeight: "700",
//     background: "radial-gradient(circle at 0% 0%, #ffde59, #ffa100)",
//     color: "#ffffff",
//     padding: "10px 12px",
//     flexShrink: 0,
//   },
//   close: {
//     background: "transparent",
//     color: "#ffffff",
//     border: "none",
//     fontSize: "18px",
//     cursor: "pointer",
//   },
//   chat: {
//     flex: 1,
//     background: "#f9f9f9",
//     padding: 12,
//     overflowY: "auto",
//     display: "flex",
//     flexDirection: "column",
//     gap: 8,
//   },
//   msg: {
//     padding: "10px 14px",
//     margin: "4px 0",
//     borderRadius: 16,
//     maxWidth: "78%",
//     whiteSpace: "pre-wrap",
//     fontSize: "14px",
//     boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
//   },
//   me: {
//     background: "#daf1ff",
//     alignSelf: "flex-end",
//     marginLeft: "auto",
//     borderBottomRightRadius: 6,
//   },
//   bot: {
//     background: "#ffffff",
//     alignSelf: "flex-start",
//     marginRight: "auto",
//     borderBottomLeftRadius: 6,
//     border: "1px solid #eee",
//   },
//   row: {
//     display: "flex",
//     gap: 8,
//     padding: "10px",
//     borderTop: "1px solid #eee",
//     background: "#fff",
//   },
//   input: {
//     flex: 1,
//     padding: "10px 12px",
//     borderRadius: 12,
//     border: "1px solid #ccc",
//     background: "#fff",
//     fontSize: "14px",
//     outline: "none",
//   },
//   button: {
//     padding: "8px 12px",
//     borderRadius: "50%",
//     border: "none",
//     background: "#f6b41a",
//     color: "#fff",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
//     minWidth: 44,
//     minHeight: 44,
//   },
// };



import React, { useEffect, useMemo, useRef, useState } from "react";

const WEBHOOK_URL = "https://apitrackk.pickkup.io/api/v1/chatbot";
const SESSION_KEY = "bhejogaadi-session-id";
const STATE_KEY = "bhejogaadi-state-b64";
const MESSAGES_KEY = "bhejogaadi-messages-v1";

function nowTimestamp() {
  const d = new Date();
  return d.toLocaleString();
}

export default function FloatingChat() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState(() => {
    try {
      const raw = localStorage.getItem(MESSAGES_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const [typing, setTyping] = useState(false);
  const chatRef = useRef(null);
  const inputRef = useRef(null);

  // sessionId - persistent
  const sessionId = useMemo(() => {
    let sid = localStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = "web-" + Math.random().toString(36).slice(2);
      localStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  }, []);

  const getState = () => localStorage.getItem(STATE_KEY) || "";
  const setState = (s) => localStorage.setItem(STATE_KEY, s || "");

  // persist messages to localStorage whenever they change
  useEffect(() => {
    try {
      localStorage.setItem(MESSAGES_KEY, JSON.stringify(messages));
    } catch (e) {
      console.warn("Could not persist messages:", e);
    }
  }, [messages]);

  // Scroll chat to bottom
  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTo({
        top: chatRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [messages, typing, busy]);

  // Add initial greeting
  useEffect(() => {
    if (open && messages.length === 0) {
      setMessages([
        {
          who: "bot",
          text: "👋 Hi! I am your assistant. How may I assist you?",
          ts: nowTimestamp(),
        },
      ]);
    }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  // focus input
  useEffect(() => {
    if (open && inputRef.current) {
      setTimeout(() => inputRef.current.focus(), 80);
    }
  }, [open]);

  // Send user message
  async function sendMessage() {
    const text = input.trim();
    if (!text || busy) return;

    const userMsg = { who: "me", text, ts: nowTimestamp() };
    setMessages((prev) => [...prev, userMsg]);

    setInput("");
    setBusy(true);
    setTyping(true);

    try {
      const res = await fetch(WEBHOOK_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Session-Id": sessionId,
        },
        body: JSON.stringify({ message: text, sessionId, state: getState() }),
      });

      const raw = await res.text();

      if (!res.ok) {
        console.error("Non-OK response from webhook:", res.status, raw);
        setMessages((prev) => [
          ...prev,
          {
            who: "bot",
            text: `⚠ Server error (${res.status}). Please try again later.`,
            ts: nowTimestamp(),
          },
        ]);
        return;
      }

      let data;
      try {
        data = raw ? JSON.parse(raw) : {};
      } catch {
        data = { reply: raw || "No reply from bot" };
      }

      const replyText =
        data.reply || data.message || data.text || "No reply from bot";

      if (data.state) {
        setState(data.state);
      }

      setMessages((prev) => [
        ...prev,
        { who: "bot", text: replyText, ts: nowTimestamp() },
      ]);
    } catch (e) {
      console.error("Chat fetch error:", e);
      setMessages((prev) => [
        ...prev,
        {
          who: "bot",
          text: "⚠ Error: unable to reach server.",
          ts: nowTimestamp(),
        },
      ]);
    } finally {
      setBusy(false);
      setTyping(false);
    }
  }

  const onKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (!busy) sendMessage();
    }
  };

  const clearChat = () => {
    setMessages([]);
    localStorage.removeItem(MESSAGES_KEY);
    localStorage.removeItem(STATE_KEY);
  };

  return (
    <>
      {!open && (
        <button
          style={styles.fab}
          onClick={() => setOpen(true)}
          aria-label="Open chat"
          title="Open chat"
        >
          <img
            src="/assets/images/bot.png"
            alt="Chatbot"
            style={{ width: 26, height: 26 }}
          />
        </button>
      )}

      {open && (
        <div style={styles.wrap} role="dialog" aria-label="Support chat window">
          <div style={styles.header}>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <span style={styles.iconCircle}>💬</span>
              <span>Pickkup Support</span>
              <span style={{ fontSize: 12, opacity: 0.9, marginLeft: 8 }}>
                {busy || typing ? "• typing…" : "• online"}
              </span>
            </div>

            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <button
                onClick={clearChat}
                title="Clear chat"
                aria-label="Clear chat"
                style={styles.clearBtn}
              >
                Clear
              </button>

              <button
                style={styles.close}
                onClick={() => setOpen(false)}
                aria-label="Close chat"
                title="Close chat"
              >
                ✖
              </button>
            </div>
          </div>

          <div
            ref={chatRef}
            style={styles.chat}
            tabIndex={0}
            aria-live="polite"
          >
            {messages.length === 0 && (
              <div style={{ textAlign: "center", color: "#888", marginTop: 16 }}>
                Start the conversation...
              </div>
            )}

            {messages.map((m, i) => (
              <div
                key={i}
                style={{
                  ...styles.msg,
                  ...(m.who === "me" ? styles.me : styles.bot),
                }}
              >
                <div style={{ whiteSpace: "pre-wrap" }}>{m.text}</div>
                <div
                  style={{
                    fontSize: 11,
                    opacity: 0.65,
                    marginTop: 6,
                    textAlign: m.who === "me" ? "right" : "left",
                  }}
                >
                  {m.ts || ""}
                </div>
              </div>
            ))}

            {typing && (
              <div style={{ ...styles.msg, ...styles.bot }}>
                <div style={{ fontStyle: "italic" }}>Meena is typing…</div>
              </div>
            )}
          </div>

          <div style={styles.row}>
            <textarea
              ref={inputRef}
              style={{ ...styles.input, resize: "none", height: 40 }}
              placeholder="Type a message"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={onKeyDown}
              disabled={busy}
              aria-label="Message input"
            />

            <button
              style={{
                ...styles.button,
                opacity: input.trim() ? 1 : 0.6,
                cursor: input.trim() && !busy ? "pointer" : "not-allowed",
              }}
              onClick={sendMessage}
              disabled={busy || !input.trim()}
              aria-label="Send message"
              title="Send"
            >
              ➤
            </button>
          </div>
        </div>
      )}
    </>
  );
}

const styles = {
  fab: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    background: "#ffffff",
    border: "1px solid #ccc",
    cursor: "pointer",
    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
    zIndex: 1001,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  wrap: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    width: "360px",
    height: "480px",
    fontFamily: "system-ui, sans-serif",
    color: "#333",
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: "12px",
    boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
    display: "flex",
    flexDirection: "column",
    zIndex: 1002,
    overflow: "hidden",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: "700",
    background: "radial-gradient(circle at 0% 0%, #ffde59, #ffa100)",
    color: "#fff",
    padding: "10px 12px",
    flexShrink: 0,
  },
  close: {
    background: "transparent",
    color: "#fff",
    border: "none",
    fontSize: "18px",
    cursor: "pointer",
  },
  clearBtn: {
    background: "transparent",
    border: "none",
    color: "#fff",
    cursor: "pointer",
    fontSize: 13,
  },
  iconCircle: {
    fontSize: 14,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
  chat: {
    flex: 1,
    background: "#f9f9f9",
    padding: 12,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  msg: {
    padding: "10px 14px",
    margin: "4px 0",
    borderRadius: 16,
    maxWidth: "78%",
    fontSize: "14px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
  },
  me: {
    background: "#daf1ff",
    alignSelf: "flex-end",
    marginLeft: "auto",
    borderBottomRightRadius: 6,
  },
  bot: {
    background: "#fff",
    alignSelf: "flex-start",
    marginRight: "auto",
    borderBottomLeftRadius: 6,
    border: "1px solid #eee",
  },
  row: {
    display: "flex",
    gap: 8,
    padding: "10px",
    borderTop: "1px solid #eee",
    background: "#fff",
  },
  input: {
    flex: 1,
    padding: "10px 12px",
    borderRadius: 12,
    border: "1px solid #ccc",
    fontSize: "14px",
    outline: "none",
  },
  button: {
    padding: "8px 12px",
    borderRadius: "50%",
    border: "none",
    background: "#f6b41a",
    color: "#fff",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    minWidth: 44,
    minHeight: 44,
    fontSize: 16,
  },
};
